import { EXTRAS_TYPE } from '@ahmdigital/constants';
import { some } from 'lodash/fp';

import { ProductType } from '../../types/product';

const hasChoosableProducts = (products: ProductType[]) => some({ extrasType: EXTRAS_TYPE.CHOOSABLE }, products);

export default hasChoosableProducts;
